import React, { Component } from "react";
import cn from "classnames";
import Timeline from "components/timeline";
import Map from "components/map";
import countryData from "data/countries.json";
import YearTicker from "components/yearTicker";
import Tools from "components/tools";
import bg from "../../assets/background.png";
import "./style.css";

const data = countryData;

class MalariaMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: props.year,
      showWithoutGMO: false,
    };

    this.toggleGMO = this.toggleGMO.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
    this.updateYear = this.updateYear.bind(this);
  }

  updateYear(year) {
    this.setState({ year, goingForwards: year > this.state.year });
  }

  toggleGMO() {
    this.setState({ showWithoutGMO: !this.state.showWithoutGMO });
  }

  componentWillUpdate(nextProps) {
    if (nextProps.year !== this.props.year) {
      this.setState({ year: nextProps.year });
    }
  }

  handleRangeChange(e) {
    const { value } = e.target;
    this.updateYear(value);
  }

  render() {
    const { year, goingForwards, showWithoutGMO } = this.state;
    const { minYear, maxYear, isCurrent, heading } = this.props;

    const countriesThatEnded = data.reduce(
      (obj, { id, yearEnded, yearEndedWithoutGMO }) => {
        const ended = showWithoutGMO ? yearEndedWithoutGMO : yearEnded;
        return {
          ...obj,
          [id]: {
            hasEnded: ended <= year,
            yearEnded: ended,
            yearEndedWithoutGMO: yearEndedWithoutGMO,
          },
        };
      },
      {}
    );

    return (
      <div id="malaria" className={"malaria"}>
        <div className="malaria__background">
          <img src={bg} />
        </div>
        <div className="malaria__tools">
          <Tools />
        </div>
        <div className="malaria__map">
          <Map data={countriesThatEnded} goingForwards={goingForwards} />
        </div>
        <div className="malaria__year">
          <YearTicker key={"ticker"} year={year} />
        </div>
        <div className="malaria__timeline">
          <Timeline />
        </div>
      </div>
    );
  }
}

MalariaMap.defaultProps = {
  minYear: 2000,
  maxYear: 2060,
};

export default MalariaMap;



// WEBPACK FOOTER //
// ./src/sections/malariaMap/index.js